import React, { useContext, useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LeaderBoard.css";
import InputBar from "../minda/InputBar/InputBar";
import { useSelector } from "react-redux";
import { AuthInfo, ConfigContext } from "../../../../App";
import { isIsoDate, jsonToURL } from "../../../../utils";
import { useSearchParams } from "react-router-dom";
import LeaderBoardUnit from "./LeaderBoardUnit";

export const LeaderBoard = (props) => {
  toast.configure();
  const { companyId, mmHost } = useContext(ConfigContext);
  const { userInfo, userId } = useContext(AuthInfo);
  const [loading, setloading] = useState(false);
  const [leaderBoardData, setLeaderBoardData] = useState({ leaderBoard: [] });
  const [fetchStatus, setFetchStatus] = useState(true);

  const [searchParams] = useSearchParams();

  let plantId = useSelector((state) => state.saveSelectedPlant);
  if (plantId.leaderBoard) {
    plantId = plantId.leaderBoard.selectedOption.value;
  } else {
    plantId = "";
  }

  let machineType = useSelector((state) => state.saveSelectedMachineType);
  if (machineType.leaderBoard) {
    machineType = machineType.leaderBoard.selectedOption.value;
  } else {
    machineType = "";
  }

  let lineId = useSelector((state) => state.saveSelectedLine);
  if (lineId.leaderBoard) {
    lineId = lineId.leaderBoard.selectedOption.value;
  } else {
    lineId = "";
  }

  let machineId = useSelector((state) => state.saveSelectedMachine);
  let machineName = "";

  if (machineId.leaderBoard) {
    machineName = machineId.leaderBoard.selectedOption.label;
    machineId = machineId.leaderBoard.selectedOption.value;
  } else {
    machineId = "";
  }

  let timings = useSelector((state) => state.timings);

  timings = timings.leaderBoard;

  let startTime = 1;
  let endTime = 1;
  if (timings) {
    startTime = timings.startTime.toISOString();
    endTime = timings.endTime.toISOString();
  }

  let queryParams = {
    startTime,
    endTime,
    plantId,
    machineType,
    lineId,
    machineId,
  };
  console.log(queryParams);

  const updateData = async () => {
    if (!isIsoDate(queryParams.startTime) || !isIsoDate(queryParams.endTime)) {
      throw "INVALID TIME FORMAT";
      return;
    }

    let leaderBoardURL = `${mmHost}/chartserver/leaderBoard?${jsonToURL(
      queryParams
    )}`;


    if (plantId == "" || !startTime || !endTime) {
      if (!startTime || !endTime) {
        // toast.error("Invalid Time Range", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        return;
      }

      // toast.info("Please Select All Plant, Line, Machine, and Time Range", {
      //   position: toast.POSITION.TOP_LEFT,
      // });
      return;
    }

    setloading(true);
    axios
      .get(leaderBoardURL)
      .then(function (data) {
        setLeaderBoardData(data.data);
        setloading(false);

        // toast.info("LeaderBoard Loaded", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        return;
      })
      .catch((e) => {
        setloading(false);
        // toast.error("LeaderBoard couldn't load", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        return;
      });
  };

  useEffect(() => {
    updateData();
  }, [fetchStatus]);

  useEffect(() => {
    setTimeout(() => {
      setFetchStatus(!fetchStatus);
    }, 500);
  }, []);

  let count = 0;
  let operators = leaderBoardData["leaderBoard"].map((operator) => {
    return (
      <Col md={6} lg={4} key={operator.userId}>
        <LeaderBoardUnit operator={operator} rank={++count}></LeaderBoardUnit>
      </Col>
    );
  });

  return (
    <>
      <div className="box box-default">
        <div className="box-header">
          <InputBar
            setData={setLeaderBoardData}
            setFetchStatus={setFetchStatus}
            fetchStatus={fetchStatus}
            loading={loading}
            InsIden={"leaderBoard"}
            machineType={false}
            line={true}
            machine={true}
            shift={false}
            shiftDate={false}
            startTime={true}
            endTime={true}
            goback={false}
            defaultOptions={{
              line: [{ value: "", label: "All" }],
              machine: [{ value: "", label: "All" }],
            }}
            startTimeDisabled={false}
            endTimeDisabled={false}
            startTimeMannual={true}
            endTimeMannual={true}
          ></InputBar>
        </div>
        <div className="box-body">
          <Row>{operators}</Row>
        </div>
      </div>
    </>
  );
};
